module.exports = __webpack_public_path__ + "static/media/instagram.295fb48a.svg";